import { forwardRef, InputHTMLAttributes, ReactNode } from 'react'

import Head from 'next/head'

import Error from '@/components/form/Error'

import { Field, FieldLabel, FieldLabelWrapper } from './Field'
import { IconWrapper, InputWrapper } from './Input.styled'

import CommonInput from './Input/CommonInput'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  error?: string
  active?: boolean
  noMargin?: boolean
  hideLabel?: boolean
  hideError?: boolean
  children?: ReactNode
  icon?: ReactNode
  dataTestId?: string
  uppercase?: boolean
}

const Input = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    label,
    error = '',
    active = false,
    noMargin = false,
    hideLabel = false,
    hideError = false,
    children,
    icon,
    dataTestId,
    uppercase,
    ...inputAttrs
  } = props

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
      </Head>
      <>
        <Field noMargin={noMargin}>
          <FieldLabelWrapper>
            <FieldLabel visuallyHidden={hideLabel}>{label}</FieldLabel>
            <InputWrapper>
              <CommonInput
                ref={ref}
                variant="inputComponent"
                invalid={!!error}
                active={active}
                data-test-id={dataTestId}
                uppercase={uppercase ? uppercase : false}
                {...inputAttrs}
              />
              {icon && <IconWrapper>{icon}</IconWrapper>}
            </InputWrapper>
          </FieldLabelWrapper>
          {children}
          {error && !hideError && (
            <Error error={error} dataTestId={dataTestId} />
          )}
        </Field>
      </>
    </>
  )
})

export default Input
